import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import React from 'react';
import {
  FDStack, FDPaper,
} from '@facet-wealth/design';
import PlannerAssignmentStepHeader
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingPostOnboardingWhatIsNext/PlannerAssignmentStepHeader';
import fr from 'facet-rest';
import RecommendedPlannerAvatarGroup
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingPlannerAssignmentRecommendedPlanner/RecommendedPlannerAvatarGroup';
import RecommendedPlannerInfo
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingPlannerAssignmentRecommendedPlanner/RecommendedPlannerInfo';
import useMobileLayout from 'Hooks/useMobileLayout';

function OnboardingPlannerAssignmentRecommendedPlanner() {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  if (!resource) return null;

  const recommendedPlannerProfileImageRel = resource.withRelationship(fr.relationships.recommendedPlannerProfileImage.name, (rel) => rel, () => null);

  return (
    <FDStack direction={'column'} spacing={6}>
      <PlannerAssignmentStepHeader resource={resource} />
      <FDPaper appearance={'outlined'} padding={2} maxWidth={isMobile ? undefined : '400px'} alignSelf={'center'}>
        <FDStack direction={'column'} spacing={3} justifyContent={'center'}>
          <RecommendedPlannerAvatarGroup
            recommendedPlannerProfileImageRel={recommendedPlannerProfileImageRel}
            restOfTeamAvatars={resource.attr('restOfTeamAvatars').resources().list()}
          />
          <RecommendedPlannerInfo resource={resource} />
        </FDStack>
      </FDPaper>
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
      />
    </FDStack>
  );
}

export default OnboardingPlannerAssignmentRecommendedPlanner;
